import { render, staticRenderFns } from "./PleaseUpgrade.vue?vue&type=template&id=2e9df3a2&scoped=true&"
import script from "./PleaseUpgrade.vue?vue&type=script&lang=js&"
export * from "./PleaseUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9df3a2",
  null
  
)

export default component.exports